import React, { Component } from 'react';
import { connect } from 'react-redux'
import { DisappearedLoading } from 'react-loadingg';
import { withRouter } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';

import './ModernHome.css'


class TurkeyPage extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
  }

  render() {
    if (!this.props.reduxDictionary) {
      return (
        <div style={{paddingBottom:"5rem"}} className="has-background-dark">
          <DisappearedLoading/>
        </div>
      );
    }

    return (
      <div className="modern-home" style={{marginBottom:"5rem"}}>
        {/* Hero Section */}
        <section className="hero is-fullheight-with-navbar modern-hero-turkey">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-vcentered">
                <div className="column is-6">
                  <div className="hero-content">
                    <h1 className="modern-title">
                      Professional Transportation Services in <span className="highlight">Turkey</span>
                    </h1>
                    <p className="modern-subtitle">
                      Reliable transfers and corporate solutions in Istanbul and beyond. Available 24/7 for your convenience.
                    </p>
                    <div className="hero-buttons">
                      <a 
                        href="https://wa.me/994502284849" 
                        className="button is-success is-large modern-btn"
                        onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_turkey_hero_' + Date.now())}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="icon"><i className="fab fa-whatsapp"></i></span>
                        <span>Contact Us on WhatsApp</span>
                      </a>
                      <Link 
                        to="/contact" 
                        className="button is-light is-large modern-btn-outline"
                      >
                        <span className="icon"><i className="fas fa-envelope"></i></span>
                        <span>Send Us a Message</span>
                      </Link>
                    </div>

                    {/* Trust Indicators */}
                    <div className="trust-indicators">
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-clock"></i>
                        </div>
                        <div className="trust-text">
                          <strong>24/7 Service</strong>
                          <span>Always Available</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-user-tie"></i>
                        </div>
                        <div className="trust-text">
                          <strong>Professional</strong>
                          <span>Experienced Drivers</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-shield-alt"></i>
                        </div>
                        <div className="trust-text">
                          <strong>Reliable</strong>
                          <span>Trusted Service</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-star"></i>
                        </div>
                        <div className="trust-text">
                          <strong>Top Rated</strong>
                          <span>5-Star Reviews</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column is-6">
                  <div className="hero-image-container">
                    <div className="floating-card">
                      <img 
                        src="https://aztur-global.s3.eu-central-1.amazonaws.com/istanbul.png" 
                        alt="Istanbul Transportation Services" 
                        className="hero-image" 
                      />
                      <div className="floating-badge">
                        <i className="fas fa-check-circle"></i>
                        <span>Serving Turkey</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Section */}
        <section className="section partnership-section">
          <div className="container">
            <div className="has-text-centered partnership-header">
              <h2 className="section-title">Trusted by Major International Events</h2>
              <p className="section-subtitle">
                Proud to support world-class events and organizations in Turkey
              </p>
            </div>

            <div className="partnership-content">
              <div className="columns is-vcentered is-multiline">
                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/f1_logo.png" alt="Formula 1" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">Formula 1</h3>
                      <p className="partnership-description">Trusted transportation partner for F1 events</p>
                    </div>
                  </div>
                </div>

                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/greenpeace.png" alt="Greenpeace" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">Greenpeace</h3>
                      <p className="partnership-description">Provided transportation support for Greenpeace environmental initiatives</p>
                    </div>
                  </div>
                </div>

                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/ufc_logo.png" alt="UFC" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">UFC</h3>
                      <p className="partnership-description">Official transportation partner for UFC events</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TripAdvisor Award Section */}
        <section className="section tripadvisor-award-section">
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-4 has-text-centered">
                <div className="award-image-container">
                  <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/tchotel_2025_L.png" alt="TripAdvisor Travellers' Choice 2025" className="award-image" />
                </div>
              </div>
              <div className="column is-8">
                <div className="award-content">
                  <h2 className="award-title">Tripadvisor Travellers' Choice™ Awards 2025</h2>
                  <p className="award-description">
                    Reviews from millions of Tripadvisor travellers place us in the top 10% worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Overview Section */}
        <section className="section modern-turkey-content">
          <div className="container">
            <div className="has-text-centered mb-6">
              <h2 className="section-title">Our Services in Turkey</h2>
              <p className="section-subtitle">
                Comprehensive transportation solutions for tourists, businesses, and events
              </p>
            </div>

            <div className="turkey-service-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-plane-arrival"></i>
                </div>
                <h3 className="feature-title">Airport Transfers</h3>
                <p className="feature-description">
                  Reliable and comfortable transfers to and from Istanbul airports (IST, SAW). Available 24/7 with professional drivers who know the best routes.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-map-marked-alt"></i>
                </div>
                <h3 className="feature-title">Tourist Land Transfers</h3>
                <p className="feature-description">
                  Explore Turkey with our comfortable vehicles and experienced local drivers. Perfect for sightseeing, day trips, and multi-day tours across the country.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-building"></i>
                </div>
                <h3 className="feature-title">Corporate Transportation</h3>
                <p className="feature-description">
                  Professional transportation solutions for companies and organizations. Employee transport, client transfers, regular routes, and executive services with reliability and professionalism.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <h3 className="feature-title">Event Support</h3>
                <p className="feature-description">
                  Comprehensive logistics for events of all sizes in Istanbul and beyond. From conferences to concerts, we handle transportation for your guests with experience in large-scale events.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Istanbul Focus Section */}
        <section className="section istanbul-focus-section">
          <div className="container">
            <div className="has-text-centered mb-6">
              <h2 className="section-title">Istanbul Services</h2>
              <p className="section-subtitle">
                Specialized transportation solutions in Turkey's vibrant metropolis
              </p>
            </div>

            <div className="columns is-multiline istanbul-services-grid">
              <div className="column is-6">
                <div className="istanbul-service-card istanbul-card-blue">
                  <div className="istanbul-card-icon">
                    <i className="fas fa-plane"></i>
                  </div>
                  <h3 className="istanbul-card-title">Istanbul Airport Transfers</h3>
                  <p className="istanbul-card-description">
                    Professional transfers to and from Istanbul Airport (IST) and Sabiha Gökçen Airport (SAW). Meet and greet service, flight tracking, and comfortable vehicles for individuals and groups.
                  </p>
                </div>
              </div>

              <div className="column is-6">
                <div className="istanbul-service-card istanbul-card-teal">
                  <div className="istanbul-card-icon">
                    <i className="fas fa-city"></i>
                  </div>
                  <h3 className="istanbul-card-title">City Transportation</h3>
                  <p className="istanbul-card-description">
                    Navigate Istanbul with ease. Transportation between hotels, business districts, tourist attractions, and event venues. Our drivers know the city inside out.
                  </p>
                </div>
              </div>

              <div className="column is-6">
                <div className="istanbul-service-card istanbul-card-purple">
                  <div className="istanbul-card-icon">
                    <i className="fas fa-users"></i>
                  </div>
                  <h3 className="istanbul-card-title">Event Venues</h3>
                  <p className="istanbul-card-description">
                    Transportation to major Istanbul event venues including convention centers, stadiums, concert halls, and conference facilities. Experienced in handling large groups efficiently.
                  </p>
                </div>
              </div>

              <div className="column is-6">
                <div className="istanbul-service-card istanbul-card-orange">
                  <div className="istanbul-card-icon">
                    <i className="fas fa-briefcase"></i>
                  </div>
                  <h3 className="istanbul-card-title">Corporate Districts</h3>
                  <p className="istanbul-card-description">
                    Regular transportation services to Istanbul's business districts including Levent, Maslak, and Ataşehir. Ideal for corporate clients and business travelers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="section modern-features">
          <div className="container">
            <div className="has-text-centered main-features-header">
              <h2 className="section-title">Why Choose Az-Tur in Turkey?</h2>
              <p className="section-subtitle">
                Your trusted partner for comfortable and reliable transportation
              </p>
            </div>

            <div className="columns is-multiline">
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-user-tie"></i>
                  </div>
                  <h3 className="feature-title">Professional Drivers</h3>
                  <p className="feature-description">
                    Experienced, licensed drivers who know Turkey's roads and speak multiple languages.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-car-side"></i>
                  </div>
                  <h3 className="feature-title">Modern Fleet</h3>
                  <p className="feature-description">
                    Well-maintained, comfortable vehicles suitable for all your transportation needs.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-headset"></i>
                  </div>
                  <h3 className="feature-title">24/7 Availability</h3>
                  <p className="feature-description">
                    Round-the-clock service for your convenience, whenever you need us.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-dollar-sign"></i>
                  </div>
                  <h3 className="feature-title">Competitive Pricing</h3>
                  <p className="feature-description">
                    Transparent pricing with no hidden fees. Quality service at fair rates.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <h3 className="feature-title">Local Expertise</h3>
                  <p className="feature-description">
                    Deep knowledge of routes, attractions, and the best ways to navigate Turkey.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <h3 className="feature-title">Safe & Reliable</h3>
                  <p className="feature-description">
                    Fully insured vehicles and professional service you can trust.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section modern-cta">
          <div className="container">
            <div className="cta-box">
              <h2 className="cta-title">Ready to Book Your Transfer in Turkey?</h2>
              <p className="cta-subtitle">Contact us now for reliable transportation services in Istanbul and across Turkey</p>
              <div className="cta-buttons">
                <a 
                  href="https://wa.me/994502284849" 
                  className="button is-success is-large"
                  onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_turkey_cta_' + Date.now())}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="icon"><i className="fab fa-whatsapp"></i></span>
                  <span>WhatsApp Us Now</span>
                </a>
                <Link to="/contact" className="button is-white is-large">
                  <span className="icon"><i className="fas fa-envelope"></i></span>
                  <span>Request Custom Quote</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}


const mapStateToProps = function (state) {
  return { 
    reduxDictionary: state.dictionary,
    serverReachable: state.serverStatus 
  }
}

export default withRouter(connect(mapStateToProps, null)(TurkeyPage))
